import * as React from "react";
const SvgCheckDouble = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M24.099 5.55953L25.1482 4.09825L22.2256 2L21.1765 3.46128L12.5212 15.5262C9.73351 12.7386 8.11486 11.1199 7.65025 10.6553L5.10986 13.2032C5.31969 13.413 7.44042 15.5337 11.4796 19.5729L12.9783 21.0716L14.2148 19.348L24.1065 5.55953H24.099ZM33.8409 15.6012L34.89 14.1399L31.9675 12.0416L30.9184 13.5029L17.3172 32.4621C12.4088 27.5537 9.93584 25.0808 9.89837 25.0433L7.35799 27.5837L8.63193 28.8576L16.2756 36.5012L17.7743 38L19.0108 36.2764L33.8484 15.5937L33.8409 15.6012Z" }));
export default SvgCheckDouble;
